import { Helmet } from "react-helmet-async";

interface DocumentMetaProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  twitterCard?: "summary" | "summary_large_image";
  noIndex?: boolean; 
}

const APP_NAME = "Christomex";
const DEFAULT_DESCRIPTION =
  "Building sustainable solutions to create a cleaner tomorrow through innovative recycling technologies";
const DEFAULT_IMAGE =
  "https://res.cloudinary.com/dklswdjev/image/upload/v1777035932/community_fortune_placeholder_lhjqlh.png";
const DEFAULT_URL = "https://christomexwasterecycling.com";

export function DocumentMeta({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url = DEFAULT_URL,
  twitterCard = "summary_large_image",
  noIndex = false,
}: DocumentMetaProps) {
  const fullTitle = title ? `${title} | ${APP_NAME}` : APP_NAME;

  return (
    <Helmet>

      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta
        name="robots"
        content={noIndex ? "noindex, nofollow" : "index, follow"}
      />


      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={APP_NAME} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:locale" content="en_GB" />


      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={fullTitle} />
    </Helmet>
  );
}
